import "./Safety.scss";
import office from "../assets/officeMedRes.webp";
import brakes from "../assets/brakesXrayMedRes.webp";
import door from "../assets/xRayX.webp";
import portrait from "../assets/portraitMedRes.webp";
import hallway from "../assets/hallwayXray.webp";
// import hallwaySVG from "../assets/HallwaySVG.svg";
import SideviewSVG from "../assets/SideviewSVG.svg";
import { useRef, useEffect, useState } from 'react';



function Safety() {
  //fade out
  const landingRef = useRef(null);
  const nextSectionRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (landingRef.current && nextSectionRef.current) {
        const nextSectionRect = nextSectionRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        // Calculate when the top of the next section reaches 50% of the viewport height
        const triggerPoint = viewportHeight * 0.5;

        // Calculate the scroll progress of the next section entering the viewport
        if (nextSectionRect.top <= triggerPoint) {
          const progress = Math.min(1, Math.max(0, (triggerPoint - nextSectionRect.top) / (nextSectionRect.height * 0.5))); // Adjust 0.5 for sensitivity
          setScrollProgress(progress);
        } else {
          setScrollProgress(0);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Calculate opacity (fading out as scrollProgress increases)
  const landingOpacity = Math.max(0, 1 - scrollProgress * 2);

  // Calculate blur (increasing as scrollProgress increases)
  const blurAmount = Math.min(1, scrollProgress * 5) * 15;

  // fade in
  const missionRef = useRef(null);
  const [isAtTop, setIsAtTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (missionRef.current) {
        const rect = missionRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const fadeOutStartThreshold = viewportHeight * 0.10; // 20% of viewport height

        // Check if the top of the div has scrolled past the point where the fade should start
        setIsAtTop(rect.top <= fadeOutStartThreshold);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <>
    <div className="width">
      <div className="safetyMain"
        >
        <div 
            ref={missionRef}
            className={`safetyTransitionImage ${isAtTop ? 'at-top' : ''}`}>
          <img src={office} className="safetyImage" alt="the threehalves robot standing behind a glass door in an office"></img>
         <span className="safetyText">
          this robot is more dangerous than it looks
         </span>
        </div>
        <div className="safetyDivider1"/>
        <div className="safetyImageContainer">
          <div className="safetyImage2">
            <img src={brakes} className="safetyImage3" alt="an xray render of the threehalves robot highlighting the brakes, pin locks, and air reservoirs"></img>
            <img src={SideviewSVG} className="safetyImage4" alt="a diagram illustrating the use of a projectile or sharp instrument to disable the robot"></img>
          </div>
          <div className="safetyTextContainer">
            <div className="safetyText2">
              ...as is any robot with humanlike strength, size, and maneuverability. We are taking a physical approach to safety mechanisms with no ambiguity. Fail-on air brakes and pin locks will render the robot immobile if system air pressure is lost. Shared reservoirs in the chest plate and body can be pierced by projectile or sharp instrument to instantly stop the robot in place.
            </div>
          </div>
        </div>
        <div className="safetyImageContainer2">
          <div className="maxWidthSafety">
        <img src={hallway} className="door" alt="a top down diagram illustrating the threehalves robot's inability to maneuver in a narrow hallway"></img>
            {/* <img src={hallwaySVG} className="safetyImage4" alt="a diagram illustrating the use of a projectile or sharp instrument to disable the robot"></img> */}
      
        <div className="safetyTextContainer2">
          <div className="safetyText2">
Threehalves will be substantially slowed if attempting to navigate a standard American 32"x80" door, and cannot turn around in a 42" wide hallway or enter a door orthogonal to the hallway. Larger horns can be fit to prevent any passage through pedestrian doors. 2 Threehalves robots fit side by side in crouched position in a pickup bed of 5'6" or longer with tailgate closed.          </div>
          </div>
          <img src={door} className="door"  alt="a front view diagram illustrating the threehalves robot's difficulty traveling through a standard size doorway"></img>
        </div>
        </div>
      
          <div className="fullwidthImage"
             >
            <img src={portrait} 
            className="fullwidthImage"

            ref={landingRef}
            style={{
             opacity: landingOpacity,
             filter: `blur(${blurAmount}px)`
            }}
             alt="a portrait of the threehalves robot standing in an office doorway"></img>
        </div>
      </div>
    </div>
    <div ref={nextSectionRef} className="next-section">
      </div>
     </>
  );
}

export default Safety;
